<template>
    <fragment>
        <div v-if="annotationsWithSameSubjectInConvenion.length > 0">
            <div
                class="rates-container"
                v-for="rates in annotationsWithSameSubjectInConvenion"
                :key="rates._uid"
            >
                <all-rates :rates="rates" :annotationOptions="annotationOptions" />
                <rates-distributions :rates="rates" :annotationOptions="annotationOptions" />
                <csp-list :cspCodes="rates.cspCodes" :conventionCspConfig="convention.cspConfig" />
            </div>
        </div>
        <div class="empty-rates-container" v-else>
            Absence de dispositions conventionnelles
        </div>
    </fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import CspList from "../../../common/CspList.vue";
import AllRates from "./AllRates.vue";
import RatesDistributions from "./RatesDistributions.vue";

export default {
    props: ["subject", "convention", "insurers", "annotationOptions"],
    components: {
        Fragment,
        CspList,
        AllRates,
        RatesDistributions,
    },
    computed: {
        annotationsWithSameSubjectInConvenion() {
            if (!this.convention.annotationsArray) return [];
            return this.convention.annotationsArray.filter(
                annotation =>
                    annotation["subject"] === this.subject.code &&
                    annotation["type"] === this.subject.type
            );
        },
    },
};
</script>

<style scoped lang="sass">
.rates-container
    display: flex
    align-items: center
    padding: 10px 0
    &:not(:last-child)
        border-bottom: 1px solid $color-grey

.empty-rates-container
    display: flex
    justify-content: center
    color: $color-grey
</style>
